import { setUploadConfig, UploadEnv } from '@meitu/xdesign-widgets/dist/uploadManager';

export enum Env {
    Release = 'Release',
    Test = 'Test',
}

interface IConfig {
    app: string;
    env: Env;
    type: string;
    needStat?: boolean;
}

const defaultConfig: IConfig = {
    app: 'xiuxiu-pro',
    //Test,Release
    env: Env.Release,
    // 上传项目的文件夹
    type: 'posters',
    // editor: 编辑器模块文件夹
    // matting: 抠图模块文件夹
    // jigsaw: 拼图模块文件夹
    // idphoto: 证件照模块文件夹
    // posters: 海报设计模块文件夹
};

// TODO, 上传还没直接收到widgets，先做转发配置已处理
const syncConfigToWidgets = () => {
    setUploadConfig({
        app: defaultConfig.app,
        env: defaultConfig.env === Env.Release ? UploadEnv.Release : UploadEnv.Test,
        type: defaultConfig.type,
        needStat: defaultConfig.needStat,
    });
};

// HACK：这里saas-editor原本有默认的type这些配置。这里只做同步默认配置用
syncConfigToWidgets();

export const setConfig = (config: Partial<IConfig>) => {
    Object.assign(defaultConfig, config);
    syncConfigToWidgets();
};

export const getConfig = () => {
    return defaultConfig;
};
